import React from 'react'

import { Box, Space } from '@gousto-internal/citrus-react'

import { CWCVideoCard } from '../../CWCVideoCard/CWCVideoCard'
import { LandingPageContentSections } from '../../../tracking'
import { CWCHowItWorksCardLabels } from './CWCHowItWorksCardLabels'

export type CWCHowItWorksStepCardProps = {
  stepNumber: number
  title: string
  body: string
  videoURL: string
  tile: string
  shouldPlay: boolean
}

export function CWCHowItWorksStepCard({
  stepNumber,
  title,
  body,
  videoURL,
  tile,
  shouldPlay,
}: CWCHowItWorksStepCardProps) {
  return (
    <Box width={['240px', null, null, null, '260px']}>
      <CWCVideoCard
        videoURL={videoURL}
        width="100%"
        height="380px"
        background="#11161B"
        boxShadow="none"
        gradient={null}
        tracking={{ section: LandingPageContentSections.HOW_RECIPE_BOXES_WORK, tile }}
        mediaLabel={title}
        data-testid="how_it_works_step_card"
        shouldPlay={shouldPlay}
      />
      <Space size={4} />
      <CWCHowItWorksCardLabels stepNumber={stepNumber} title={title} body={body} />
    </Box>
  )
}
